import { isMobile, resizeGame } from '@pascal/pascal-core';

const maxHeight = 846;
const maxWidth = 1494;
const target = document.querySelector('#root');

export const resizeGameHandler = () => {
  resizeGame(maxHeight, maxWidth, target);
};

export const setupResolution = () => {
  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
  } else {
    resizeGameHandler();
    window.addEventListener('resize', resizeGameHandler);
    document.documentElement.classList.add('is-web');
  }
};
